<template>
  <div class="installpwa">
    <div v-if="!pwaInstalled">
      <div v-if="!pwaCanBeInstalled">
        <!-- <div>
          Download from the Store
        </div> -->
        <div>
          {{
            $t(
              "If you already installed Mail2Self, just use the Share function in your phone to"
            )
          }}
          <br />
          <b>{{ $t("Share with") }} > Mail2Self</b>
        </div>
      </div>
      <div v-else>
        <button
          class="button-primary button-round button-large"
          @click="pwaInstall()"
        >
          {{ $t("Install") }}
        </button>
      </div>
    </div>
    <div v-else class="alert alert-warning">
      <h5>
        Mail2Self {{ $t("is") }} <br />
        {{ $t("installed and active") }}
      </h5>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as utils from "@/utils";

export default {
  name: "InstallPWA",

  props: {
    msg: String,
  },

  computed: {
    ...mapState("installPWA", [
      "pwaCanBeInstalled",
      "pwaInstallPrompt",
      "pwaInstalled",
    ]),
  },

  methods: {
    pwaInstall() {
      this.pwaInstallPrompt.prompt();
      // Wait for the user to respond to the prompt
      this.pwaInstallPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          null;
        } else {
          null;
        }
      });
    },

    installed() {
      this.$store.commit("installPWA/pwaInstalledMutation", true);
    },

    checkInstalled() {
      let vm = this;
      if (window.matchMedia("(display-mode: standalone)").matches) {
        this.$store.commit("installPWA/pwaInstalledMutation", true);
        // TODO: Wait for support for getInstalledRelatedApps()
        // } else if ("getInstalledRelatedApps" in navigator) {
        //   navigator.getInstalledRelatedApps().then((relatedApps) => {
        //     if (!relatedApps) {
        //       vm.$store.commit("installPWA/pwaInstalledMutation", false);
        //     } else {
        //       vm.$store.commit("installPWA/pwaInstalledMutation", true);
        //     }
        //   });
      }
    },
  },

  created() {
    window.addEventListener("beforeinstallprompt", (event) => {
      event.preventDefault();
      this.$store.commit("installPWA/pwaInstallPromptMutation", event);
      this.$store.commit("installPWA/pwaCanBeInstalledMutation", true);
    });

    window.addEventListener("appinstalled", (evt) => {
      this.installed();
    });

    this.checkInstalled();
    window.addEventListener("resize", this.checkInstalled);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
